import React from 'react';
import { useSelector } from 'react-redux';

const CodeTotalsIndicator = () => {
    // TODO: make sure these are properly hooked up in Redux
    const daylightCodeCount = useSelector(state => state.daylight.daylightCodeCount.toLocaleString('en-US'));
    const daylightTotalCodesCount = useSelector(state => state.daylight.daylightTotalCodesCount.toLocaleString('en-US'));
    return (
        <div>
            Total: {daylightCodeCount} Codes of {daylightTotalCodesCount} Codes
        </div>
    );
};

export default CodeTotalsIndicator;
